/** Niveaux de confidentialité du profil (spécifications § 7.2). */
export type PrivacyLevelValue = 'public' | 'friends' | 'private' | 'ghost'

/** L'ordre d'affichage va du plus ouvert au plus fermé. */
export const PRIVACY_LEVELS: readonly PrivacyLevelValue[] = [
  'public',
  'friends',
  'private',
  'ghost',
]

/** Motifs de signalement acceptés par l'API (spécifications § 7.3). */
export type ReportReasonValue =
  | 'inappropriate_content'
  | 'harassment'
  | 'impersonation'
  | 'spam'

export const REPORT_REASONS: readonly ReportReasonValue[] = [
  'inappropriate_content',
  'harassment',
  'impersonation',
  'spam',
]

/** Portées de classement disponibles en v1. */
export type LeaderboardScope = 'friends' | 'global'

export interface UserSearchResult {
  id: string
  username: string | null
  /** Nom réel, renvoyé uniquement par les profils publics. */
  display_name: string | null
  avatar_url: string | null
  is_friend: boolean
  request_pending: boolean
}

export interface Friend {
  id: string
  username: string | null
  display_name: string | null
  avatar_url: string | null
  xp_total: number
}

export interface PendingRequest {
  id: string
  requester: {
    id: string | null
    username: string | null
    avatar_url: string | null
  }
  created_at: string | null
}

export interface FriendsOverview {
  friends: Friend[]
  pending: PendingRequest[]
}

export interface PrivacySettings {
  /** Niveau effectif : déjà abaissé par l'API pour un mineur protégé. */
  level: PrivacyLevelValue
  /** Faux quand l'âge verrouille le niveau. */
  can_choose: boolean
  /** Faux quand l'ajout d'amis attend un accord parental. */
  friends_enabled: boolean
}

export interface LeaderboardEntry {
  rank: number
  user_id: string
  username: string | null
  avatar_url: string | null
  xp_total: number
  is_me: boolean
}

export interface ReportPayload {
  user_id: string
  reason: ReportReasonValue
  details?: string
}
